import { render, staticRenderFns } from "./DynamicTabs.vue?vue&type=template&id=d889fa5e&"
import script from "./DynamicTabs.vue?vue&type=script&lang=js&"
export * from "./DynamicTabs.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTabs.vue?vue&type=style&index=0&id=d889fa5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports